import * as contractActions from "@rentiohq/shared-frontend/dist/reduxV2/contract/contract.actions";
import * as contractSelectorsV2 from "@rentiohq/shared-frontend/dist/reduxV2/contract/contract.selectors";
import { IRootStore } from "redux/reducers";
import { EField, IExtraData } from "./schema.requestRentioMoveService.types";

export const performingSubmitActionResultSelector =
  (contractId: string) => (state: IRootStore) =>
    contractSelectorsV2.isRequestingRentioMoveService(state, contractId);

export const submitActionCreator =
  (extraData: IExtraData) => (formData: any) => {
    const { contract, energyTransferByMexp } = extraData;
    return contractActions.requestRentioMoveServiceStart.getAction({
      id: contract.id,
      data: {
        ...formData,
        energyTransferByMexp,
        [EField.NoContract]: formData[EField.NoContract] === "yes",
        [EField.NewTenant]: formData[EField.NewTenant]?.[0],
        [EField.DepartingTenant]: formData[EField.DepartingTenant]?.[0],
      },
    });
  };
